import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const MINING_AND_GEOLOGY: Layer = {
  id: ConstraintsCategory.MINING_AND_GEOLOGY,
  layerType: ConstraintsLayerType,
  title: "Coal mining",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.ENVIRONMENTAL,
  icon: "lt-oil-line",
  description: "Historical coal mining risks",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
    // DO NOT REMOVE maxVisibleZoom. Required for licensing reasons
    maxVisualisationZoom: 14,
    maxConsiderationZoom: 14,
    // DO NOT REMOVE maxVisibleZoom. Required for licensing reasons
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.MINING_AND_GEOLOGY,
    categorySchema: [
      { key: "mine_entries" },
      { key: "coal_development_high_risk_areas" },
      { key: "surface_mining" },
      { key: "past_shallow_coal_workings" },
      { key: "probable_shallow_coal_workings" },
      { key: "coal_mining_reporting_areas" },
    ],
  },
};
